import React, { createContext, useCallback, useContext, useMemo, useRef, useState } from 'react';

const DashboardProjectFocusContext = createContext(null);

export function DashboardProjectFocusProvider({ children }) {
    const [projectSidebar, setProjectSidebar] = useState(null);
    const exitHandlerRef = useRef(() => {});

    const registerDashboardProjectExit = useCallback((fn) => {
        exitHandlerRef.current = typeof fn === 'function' ? fn : () => {};
    }, []);

    const exitProjectDashboardMode = useCallback(() => {
        exitHandlerRef.current();
    }, []);

    const value = useMemo(
        () => ({
            projectSidebar,
            setProjectSidebar,
            registerDashboardProjectExit,
            exitProjectDashboardMode,
        }),
        [projectSidebar, registerDashboardProjectExit, exitProjectDashboardMode]
    );

    return (
        <DashboardProjectFocusContext.Provider value={value}>
            {children}
        </DashboardProjectFocusContext.Provider>
    );
}

export function useDashboardProjectFocus() {
    const ctx = useContext(DashboardProjectFocusContext);
    if (!ctx) {
        return {
            projectSidebar: null,
            setProjectSidebar: () => {},
            registerDashboardProjectExit: () => {},
            exitProjectDashboardMode: () => {},
        };
    }
    return ctx;
}
